import React, { useContext, useEffect, useState } from 'react';
import { Col, Row } from '@thd-olt-component-react/core-ui';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { SuperSkuMiniSwatches } from '@thd-olt-component-react/super-sku';
import { ProductATC } from '../product-atc/ProductATC';
import { ProductFavorites } from '../product-favorites/ProductFavorites';
import { ProductHeader } from '../product-header/ProductHeader';
import { ProductImage } from '../product-image/ProductImage';
import { ProductPodContext } from '../../ProductPodContext';
import { ProductPrice } from '../product-price/ProductPrice';
import { ProductQuantity } from '../product-quantity/ProductQuantity';
import { ProductRating } from '../product-rating/ProductRating';
import { ProductShipping } from '../product-shipping/ProductShipping';
import { ProductStore } from '../product-store/ProductStore';
import { ProductQuoteCenter } from '../product-quote-center/ProductQuoteCenter';
import { ProductEditButton } from '../product-edit/ProductEditButton';
import { isATCEnabled } from '../../utils';
import './product-side-by-side.style.scss';

export const ProductSideBySide = () => {
  const {
    channel,
  } = useContext(ExperienceContext);
  const {
    hideLimitPerOrder,
    hideShippingInfo,
    hideStoreInfo,
    isATCDisabled,
    isHovered,
    itemId,
    onChangeSuperSku,
    onFavoriteChange,
    onHoverSuperSku,
    previousItemId,
    product,
    onEdit,
    storeId,
    isHDQCSku,
    showDisabledATC,
    staticQuantity
  } = useContext(ProductPodContext);

  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  const isDisabled = isATCDisabled;
  const superSkuItemId = isHovered ? previousItemId : itemId;
  const isMobile = channel === 'mobile';

  return (

    <Row>

      <Col>
        {
          onEdit && (<ProductEditButton nopadding onClick={onEdit} />)
        }
        <div className="side-by-side__title-wrapper">
          <ProductHeader brand="inline" collection="hidden" />
        </div>
      </Col>
      <Col fallback="6">
        <ProductImage className="product-image" />
        <ProductFavorites
          className="product-pod__inline__favorite"
          onFavoriteChange={onFavoriteChange}
          position="topRight"
          showCircle
        />
      </Col>
      <Col fallback="6" className="flex-column" nopadding>
        <ProductRating />

        {
          staticQuantity && (
            <div className="qty-text-wrapper">
              <ProductQuantity textOnly showQtyText smallText showQtyValueText />
            </div>
          )
        }

        { isHDQCSku ? (
          <ProductQuoteCenter />
        ) : (
          <>
            <ProductPrice hideLimitPerOrder={hideLimitPerOrder} large={false} />
            {mounted && (
              <SuperSkuMiniSwatches
                itemId={superSkuItemId}
                storeId={storeId}
                onChange={onChangeSuperSku}
                onHover={onHoverSuperSku}
              />
            )}
            { !hideStoreInfo && (<ProductStore />) }
            { !hideShippingInfo && (<ProductShipping className="product-pod__fulfillment--shipping-collection" />) }
            { (isATCEnabled(product) || showDisabledATC) && (
              <Col className="atc-wrapper" nopadding>
                { !isMobile && !staticQuantity && (
                  <Col
                    xs="3"
                    nopadding
                  >
                    <ProductQuantity textOnly />
                  </Col>
                ) }
                <Col
                  xs="7"
                  nopadding
                >
                  <ProductATC outline disabled={isDisabled} />
                </Col>
              </Col>
            )}
          </>
        )}
      </Col>
    </Row>
  );
};

ProductSideBySide.displayName = 'ProductPodSideBySide';
